// Kachel "Umsatzentwicklung" (Welle 1, #3): Trend aus dem BEREITS geladenen Serien-Payload.
// Es gibt keinen Vorperioden-Endpoint — der Vergleich laeuft ehrlich beschriftet
// 2. Haelfte vs. 1. Haelfte des gewaehlten Zeitraums. Ungerade Bucket-Zahl: die Mitte
// zaehlt zur 2. Haelfte (juengere Haelfte nie kleiner als die aeltere).
import type { DashSeriesBucket } from "@/api/dashboard";

export function bucketTotals(buckets: DashSeriesBucket[], channels: string[]): number[] {
  return buckets.map((b) => channels.reduce((s, ch) => s + (b.values[ch] ?? 0), 0));
}

export function halfPeriodTrend(totals: number[]): { pct: number | null; dir: "up" | "down" } {
  const mid = Math.floor(totals.length / 2);
  const first = totals.slice(0, mid).reduce((a, b) => a + b, 0);
  const second = totals.slice(mid).reduce((a, b) => a + b, 0);
  if (first <= 0) return { pct: null, dir: "up" };
  const pct = Math.round(((second - first) / first) * 100);
  return { pct, dir: pct < 0 ? "down" : "up" };
}
